import React from "react";
import { useTranslation } from "@/langs/useTranslation";
import { BreadCrumbs } from "@/components/device/BreadCrumbs";
import useStyles from "@/styles/groupsStyle";
import AnnouncementTable from "./AnnouncementTable";

const Announcement = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <BreadCrumbs noTranslate pageName={t({ defaultMessage: "通知公告" })} />
      <div className={classes.paperWrapper}>
        <AnnouncementTable />
      </div>
    </>
  );
};

export default Announcement;
